import React, { useContext } from "react";

import PropTypes from "prop-types";
import SwitchContext from "../context";
// import { getImageIds } from "../../shoppingsite/utils";
// import { useNavigate } from "react-router-dom";
import ProductCard from "./ProductCard";
import OwnTabletImg from "../../../assets/images/tablet.png";
import OwnTerminalImg from "../../../assets/images/terminal.webp";
import styled from "styled-components";
import { getPlanForDevices } from "../../../utils/planLadder";
import { resolveEquipDiscount } from "../../../utils/equipDiscount";
const OWN_HARDWARE_ART = {
  "Own Tablet": OwnTabletImg,
  "Own Terminal": OwnTerminalImg,
};

function RecommendedDevices({
  initialCartItems,
  items,

  //   settLoading,
}) {
  //   console.log({ initialCartItems });
  let monthlyFee, planType, uzeliPlan;
  //   const navigate = useNavigate();

  const totalSmartCheckout =
    initialCartItems["Pax Aries 8 Checkout Terminal with Stand"] ||
    initialCartItems["Pax Aries 8 Checkout Terminal"] ||
    0;
  const totalKiozzkCount = initialCartItems["Growthzilla Kiozzk Tablet"] || 0;
  // const totalReceiptPrinter =
  //   initialCartItems["Growthzilla Cloud Receipt Printer"];
  // const totalCashDrawer =
  //   initialCartItems["Small CashDrawer"] + initialCartItems["Large CashDrawer"];
  // const totalAriesStand =
  //   initialCartItems["Aries8/Aries6 Stand"] || initialCartItems["Aries Stand"];
  const totalComputer = initialCartItems["Computer"] || 0;

  // Matches useDeviceCounter: a customer-supplied tablet occupies a device slot.
  const totalOwnTablet = initialCartItems["Own Tablet"] || 0;

  const deviceCount =
    totalKiozzkCount + totalComputer + totalSmartCheckout + totalOwnTablet;

  const CustomButton = styled.button`
   { padding-top: 1rem;
    padding-bottom: 1rem;
    margin: 0.2rem;
    font-weight: 400;
    --tw-text-opacity: 1;
    color: rgba(55, 22, 80, var(--tw-text-opacity));
    border-radius: 0.25rem;
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgba(55, 22, 80, var(--tw-border-opacity));
    &:hover {
      --tw-bg-opacity: 1;
      background-color: rgba(55, 22, 80, var(--tw-bg-opacity));
      color: rgba(255, 255, 255, var(--tw-text-opacity));
    }
  `;
  // planType is assigned but not rendered here — the "Plan Type" button below
  // is commented out. Kept so uncommenting it needs no other change.
  // eslint-disable-next-line no-unused-vars
  ({ monthlyFee, planType, uzeliPlan } = getPlanForDevices({
    deviceCount,
    totalSmartCheckout,
    totalKiozzkCount,
    totalComputer,
  }));
  const equipmentPrice = { MobileApp: 50, Website: 50, EmailMarketing: 19 };
  uzeliPlan =
    uzeliPlan +
    (initialCartItems["Mobile App"] ? " + Mobile App" : "") +
    (initialCartItems["Website"] ? " + Website" : "") +
    (initialCartItems["Email Marketing"] ? " + Email Marketing" : "");

  monthlyFee =
    monthlyFee +
    (initialCartItems["Mobile App"] ? equipmentPrice.MobileApp : 0) +
    (initialCartItems["Website"] ? equipmentPrice.Website : 0) +
    (initialCartItems["Email Marketing"] ? equipmentPrice.EmailMarketing : 0);

  const productImage = (name) => {
    if (name === "Growthzilla Kiozzk Tablet") {
      return items?.find((item) => item?.name === "Growthzilla Kiozzk");
    } else if (name === "Pax Aries 8 Checkout Terminal with Stand") {
      return items?.find((item) => item?.name === "Smart Checkout");
    } else if (name === "Pax Aries 8 Checkout Terminal") {
      return items?.find((item) => item?.name === "Smart Checkout");
    } else if (name === "Growthzilla Cloud Receipt Printer") {
      return items?.find(
        (item) => item?.name === "Growthzilla Cloud Receipt Printer"
      );
    } else if (name === "Small CashDrawer") {
      return items?.find((item) => item?.name === 'Cash Drawer Small(13")');
    } else if (name === "Large CashDrawer") {
      return items?.find((item) => item?.name === 'Cash Drawer Big(16")');
    } else if (name === "Computer") {
      return items?.find((item) => item?.name === "Computer");
    } else if (name === "Aries8/Aries6 Stand") {
      return items?.find((item) => item?.name === "Aries8/Aries6 Stand");
    } else if (name === "Aries Stand") {
      return items?.find((item) => item?.name === "Aries8/Aries6 Stand");
    } else if (name === "Own Tablet") {
      return items?.find((item) => item?.name === "Own Tablet");
    } else if (name === "Own Terminal") {
      return items?.find((item) => item?.name === "Own Terminal");
    }
  };

  //   useEffect(() => {
  //     fetchInventory();
  //   }, []);
  const totalAmount = Object.keys(initialCartItems).reduce((acc, item) => {
    // Guard against keys with no resolvable inventory price (e.g. a stray
    // non-equipment key in the webhook) so one bad entry can't turn the whole
    // total into NaN and silently kill the discount.
    const price = Number(productImage(item)?.unitPrice) || 0;
    const qty = Number(initialCartItems[item]) || 0;
    return acc + price * qty;
  }, 0);
  console.log("initialCartItems", initialCartItems);
  //   console.log({ items });
  //   const getItemName
  const {
    equipDiscount,
    equipDiscountType,
    qualifyingEquipmentPrice,
    qualifyingPlanPrice,
    planPermDiscount,
    planTempDiscount,
    tempDiscountExpiryDate,
  } = useContext(SwitchContext);

  // Proma may send the discount as a percentage of the equipment total rather
  // than a flat amount, so resolve it before it is shown or subtracted.
  const equipDiscountAmount = resolveEquipDiscount(
    equipDiscount,
    equipDiscountType,
    totalAmount
  );
  // Was `totalAmount >= equipDiscount`, which compared the cart total against
  // the discount itself — a $100 discount "qualified" on any cart over $100,
  // regardless of the minimum spend. The threshold is qualifyingEquipmentPrice,
  // matching useDeviceCounter's `setUpFee >= qualifyingEquipmentPrice`.
  const discountOnSetupFee =
    equipDiscountAmount > 0 &&
    totalAmount >= Number(qualifyingEquipmentPrice || 0);

  // Monthly-fee discount — same rule as the main summary (Document.jsx):
  // permanent discount always applies; temporary discount only until its expiry;
  // and only when the plan fee reaches the qualifying plan price.
  const discountOnMonthlyFee = monthlyFee >= qualifyingPlanPrice;
  const monthlyDiscount =
    (Number(planPermDiscount || 0) +
      (new Date(tempDiscountExpiryDate) > new Date()
        ? Number(planTempDiscount || 0)
        : 0)) *
    Number(discountOnMonthlyFee);
  const monthlyAfterDiscount = monthlyFee - monthlyDiscount;
  //   console.log("equipDiscount",{
  //     uzeliPlan,
  //     planType,
  //     monthlyFee,
  //     qualifyingEquipmentPrice,
  //     equipDiscount,
  //   },{
  //   qualifyingEquipmentPrice,
  //   equipDiscount,
  //   qualifyingPlanPrice,
  //   planPermDiscount,
  //   planTempDiscount,
  //   tempDiscountExpiryDate,
  // });
  const totalAfterDiscount = totalAmount - equipDiscountAmount;
  //   console.log({ planType });

  return (
    <div className="w-full">
      <div className=" flex flex-col md:flex-row justify-evenly md:px-10 mb-5 gap-2">
        <CustomButton className="w-full md:[w-40%]">
          <div className="flex flex-col gap-1 ">
            <div className="text-sm">Uzeli Plan</div>
            {/* <br /> */}
            <div className="font-semibold">{uzeliPlan}</div>
          </div>
        </CustomButton>
        {/* <br /> */}
        <CustomButton className="w-full md:[w-40%]">
          <div className="flex flex-col   gap-1 ">
            <div className="text-sm">Plan Monthly Fee</div>
            {monthlyDiscount > 0 ? (
              <div className="font-semibold flex gap-2 justify-center items-center">
                <span className="line-through opacity-60">${monthlyFee}</span>
                <span>${monthlyAfterDiscount}</span>
              </div>
            ) : (
              <div className="font-semibold">${monthlyFee}</div>
            )}
          </div>
        </CustomButton>
        {/* <CustomButton>
          <div className="flex  gap-3 ">
            <div className="text-sm">Plan Type</div>
            <div className="font-semibold">{planType}</div>
          </div>
        </CustomButton> */}
      </div>
      <div className="w-full flex flex-col justify-center gap-3">
        {/* <h3 className="w-full flex justify-center">
          Your Growthzilla partner has offered you following equipment as part
          of package
        </h3> */}
        {initialCartItems && Object.keys(initialCartItems).length > 0 && (
          <div className="w-full md:px-5 lg:px-20  flex flex-col justify-center">
            <ol className="w-full">
              {Object.keys(initialCartItems).map((item, index) => {
                if (
                  item === "Mobile App" ||
                  item === "Website" ||
                  item === "Email Marketing"
                ) {
                  return null;
                }
                const product = {
                  name: item,
                  quantity: initialCartItems[item],
                  imageId: productImage(item)?.imageId,
                  price: productImage(item)?.unitPrice,
                };
                // Customer-supplied hardware has no inventory row, so imageId is
                // null and the card fell back to the generic placeholder. Use the
                // same artwork the selection pages show for these two, so the
                // recommendation looks like what the customer already chose from.
                const fallback = OWN_HARDWARE_ART[item];
                return (
                  <div key={item} className="flex w-full justify-center">
                    <ProductCard
                      index={index}
                      item={product}
                      fallback={fallback}
                    />
                  </div>
                );
              })}
            </ol>
            <div className="flex w-full justify-evenly font-semibold">
              <table className="w-full justify-center">
                <tbody>
                  <tr className="flex justify-center w-full  ">
                    <td className="w-[50%]">Total</td>
                    <td className="pl-[10%]">${totalAmount}</td>
                  </tr>
                  {discountOnSetupFee && (
                    <>
                      <tr className="flex justify-center w-full ">
                        <td className="w-[50%]">Discount</td>
                        <td className="pl-[10%]">
                          <span className="flex gap-1   ">
                            <div>-</div>
                            <div>${equipDiscountAmount}</div>
                          </span>
                        </td>
                      </tr>
                      <tr className="flex w-full my-1 justify-center">
                        <td className="w-full">
                          <hr className="w-[90%] md:[w-80%] font-bold justify-center " />
                        </td>
                      </tr>
                      <tr className="flex justify-center capitalize w-full items-center ">
                        <td className="w-[50%] ">Total after discount</td>
                        <td className="pl-[10%]">${totalAfterDiscount}</td>
                      </tr>
                    </>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

RecommendedDevices.propTypes = {
  initialCartItems: PropTypes.object,
  items: PropTypes.array,
};

export default RecommendedDevices;
